// TODO Use common.View.create since this is an view.
({

    init() {
        $(this.onDOMLoad.bind(this));
    },

    onDOMLoad() {
        this.initSideBar();
    },

    initSideBar() {
        // @Ugly: fix double active state in menu.
        let $sidebar = $('.admin\\:\\:layouts-main-sidebar-Structure');

        // Check if there are more then one actives in submenu's
        if($sidebar.find('nav > ul > li > ul > li.active').length > 1) {

            // Remove the first active state.
            $sidebar.find('nav > ul > li > ul > li.active:first-of-type').removeClass('active');
        }
    },

    // @TODO high: check if still workingin V2-redesign?
    initReadNotification() {
        $('.message-center > *')
            .on('click', (event) => {
                // Set notification read
                $.post('/'+ ($('html').data('prefix') !== undefined ? $('html').data('prefix') : 'admin/') +'notifications/' + $(event.currentTarget).data('id'))
                    .done(() => {
                        window.location.href = $(event.currentTarget).attr('href');
                    });

                return false;
            });
    },

}).init();
